import { connect } from 'react-redux';
import TambahJurusan from '../../../views/Akademi/DataKelas/TambahJurusan.view';

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

export default connect(mapStateToProps)(TambahJurusan);
